export default __webpack_public_path__ + "static/media/feb01.2515aee5.jpg";